// eslint-disable-next-line import/prefer-default-export
// eslint-disable-next-line no-unused-vars
// 在数组对象中去掉重复的对象函数
const DeleteCopy = {
  methods: {
    deteleObject(obj) {
      let uniques = [];
      const stringify = {};
      for (let i = 0; i < obj.length; i++) {
        const keys = Object.keys(obj[i]);
        // eslint-disable-next-line func-names
        keys.sort((a, b) => {
          return Number(a) - Number(b);
        });
        let str = "";
        for (let j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        // eslint-disable-next-line no-prototype-builtins
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      // eslint-disable-next-line no-self-assign
      uniques = uniques;
      return uniques;
    }
  }
};
export default DeleteCopy;
